var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('c-source-detail',{attrs:{"columns":_vm.columns,"data":_vm.data,"resource":"after_sales"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }